import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getDependencyArray } from 'redux/PlannerModeSlice';

interface Properties {
  isOpen: boolean;
  onClose: () => void;
  itemName: string;
  onDelete: () => void;
  orgChart?: any;
  isBuilderMode?: boolean;
}

const DeleteGroupModal = ({
  isOpen,
  onClose,
  itemName,
  onDelete,
  orgChart,
  isBuilderMode = false,
}: Properties) => {
  const deleteIndicatorDependecyData = useSelector(getDependencyArray);
  const summaryString = `this ${itemName} indicator as it's referenced in:\n${deleteIndicatorDependecyData?.dependent_indicators
    ?.map((item: any) => `- ${item.block_name} . ${item.name}`)
    .join('\n')}`;
  const isIndicatorDependency =
    deleteIndicatorDependecyData &&
    deleteIndicatorDependecyData?.dependent_indicators?.length > 0 &&
    isBuilderMode;
  const name = isIndicatorDependency ? summaryString : itemName;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={isIndicatorDependency ? '3xl' : 'xs'}
      blockScrollOnMount={false}
    >
      <ModalOverlay />
      <ModalContent pb={3} width={isIndicatorDependency ? 400 : 62.5}>
        <ModalHeader position='relative'>
          <Text variant='modal' size='subTitle' align='center'>
            Confirm your action
          </Text>
        </ModalHeader>
        <ModalBody>
          <Text variant='modal' size='modalContent'>
            Are you sure you want to delete{' '}
            <Text as='span' size='subTitle' whiteSpace='pre-line'>
              {name}
            </Text>
            {orgChart ? '' : '? This will also delete all the items in the group.'}
          </Text>
        </ModalBody>

        <ModalFooter pb='0'>
          <HStack spacing='5'>
            <Button variant='clear' size='auto' fontSize='xs' color='red.500' onClick={onClose}>
              Cancel
            </Button>
            <Button variant='clear' size='auto' fontSize='xs' color='violet.900' onClick={onDelete}>
              Confirm
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteGroupModal;
